import { FunctionComponent } from 'react';

const SigningIn: FunctionComponent = () => (
  <div className="text-center">
    <p>Redirecting to sign in. Please wait.</p>
  </div>
);

export default SigningIn;
